// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-notes-scope .tw-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
.project-notes-scope .tw-pointer-events-none {
    pointer-events: none;
}
.project-notes-scope .tw-pointer-events-auto {
    pointer-events: auto;
}
.project-notes-scope .tw-invisible {
    visibility: hidden;
}
.project-notes-scope .tw-fixed {
    position: fixed;
}
.project-notes-scope .tw-absolute {
    position: absolute;
}
.project-notes-scope .tw-relative {
    position: relative;
}
.project-notes-scope .tw-inset-0 {
    inset: 0px;
}
.project-notes-scope .tw-inset-x-0 {
    left: 0px;
    right: 0px;
}
.project-notes-scope .tw-inset-y-0 {
    top: 0px;
    bottom: 0px;
}
.project-notes-scope .tw-bottom-4 {
    bottom: 1rem;
}
.project-notes-scope .tw-bottom-full {
    bottom: 100%;
}
.project-notes-scope .tw-left-0 {
    left: 0px;
}
.project-notes-scope .tw-left-1\\/2 {
    left: 50%;
}
.project-notes-scope .tw-right-0 {
    right: 0px;
}
.project-notes-scope .tw-right-3 {
    right: 0.75rem;
}
.project-notes-scope .tw-top-0 {
    top: 0px;
}
.project-notes-scope .tw-z-10 {
    z-index: 10;
}
.project-notes-scope .tw-z-30 {
    z-index: 30;
}
.project-notes-scope .tw-z-\\[120000\\] {
    z-index: 120000;
}
.project-notes-scope .tw-z-\\[1202\\] {
    z-index: 1202;
}
.project-notes-scope .tw-z-\\[1250\\] {
    z-index: 1250;
}
.project-notes-scope .tw-z-\\[1320\\] {
    z-index: 1320;
}
.project-notes-scope .tw-z-\\[1400\\] {
    z-index: 1400;
}
.project-notes-scope .tw-m-0 {
    margin: 0px;
}
.project-notes-scope .tw-mx-auto {
    margin-left: auto;
    margin-right: auto;
}
.project-notes-scope .tw-my-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
}
.project-notes-scope .tw-my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
}
.project-notes-scope .tw-my-auto {
    margin-top: auto;
    margin-bottom: auto;
}
.project-notes-scope .tw-mb-0 {
    margin-bottom: 0px;
}
.project-notes-scope .tw-mb-1 {
    margin-bottom: 0.25rem;
}
.project-notes-scope .tw-mb-2 {
    margin-bottom: 0.5rem;
}
.project-notes-scope .tw-mb-2\\.5 {
    margin-bottom: 0.625rem;
}
.project-notes-scope .tw-mb-3 {
    margin-bottom: 0.75rem;
}
.project-notes-scope .tw-mb-4 {
    margin-bottom: 1rem;
}
.project-notes-scope .tw-mb-5 {
    margin-bottom: 1.25rem;
}
.project-notes-scope .tw-mb-6 {
    margin-bottom: 1.5rem;
}
.project-notes-scope .tw-mb-\\[100px\\] {
    margin-bottom: 100px;
}
.project-notes-scope .tw-ml-0\\.5 {
    margin-left: 0.125rem;
}
.project-notes-scope .tw-ml-2 {
    margin-left: 0.5rem;
}
.project-notes-scope .tw-mr-1 {
    margin-right: 0.25rem;
}
.project-notes-scope .tw-mr-1\\.5 {
    margin-right: 0.375rem;
}
.project-notes-scope .tw-mt-0 {
    margin-top: 0px;
}
.project-notes-scope .tw-mt-0\\.5 {
    margin-top: 0.125rem;
}
.project-notes-scope .tw-mt-1 {
    margin-top: 0.25rem;
}
.project-notes-scope .tw-mt-2 {
    margin-top: 0.5rem;
}
.project-notes-scope .tw-mt-3 {
    margin-top: 0.75rem;
}
.project-notes-scope .tw-mt-4 {
    margin-top: 1rem;
}
.project-notes-scope .tw-mt-5 {
    margin-top: 1.25rem;
}
.project-notes-scope .tw-mt-6 {
    margin-top: 1.5rem;
}
.project-notes-scope .tw-box-border {
    box-sizing: border-box;
}
.project-notes-scope .tw-block {
    display: block;
}
.project-notes-scope .tw-inline-block {
    display: inline-block;
}
.project-notes-scope .tw-flex {
    display: flex;
}
.project-notes-scope .tw-inline-flex {
    display: inline-flex;
}
.project-notes-scope .tw-grid {
    display: grid;
}
.project-notes-scope .tw-hidden {
    display: none;
}
.project-notes-scope .tw-size-3 {
    width: 0.75rem;
    height: 0.75rem;
}
.project-notes-scope .tw-size-3\\.5 {
    width: 0.875rem;
    height: 0.875rem;
}
.project-notes-scope .tw-size-4 {
    width: 1rem;
    height: 1rem;
}
.project-notes-scope .tw-size-6 {
    width: 1.5rem;
    height: 1.5rem;
}
.project-notes-scope .tw-size-7 {
    width: 1.75rem;
    height: 1.75rem;
}
.project-notes-scope .tw-size-8 {
    width: 2rem;
    height: 2rem;
}
.project-notes-scope .tw-size-9 {
    width: 2.25rem;
    height: 2.25rem;
}
.project-notes-scope .tw-h-10 {
    height: 2.5rem;
}
.project-notes-scope .tw-h-11 {
    height: 2.75rem;
}
.project-notes-scope .tw-h-12 {
    height: 3rem;
}
.project-notes-scope .tw-h-2 {
    height: 0.5rem;
}
.project-notes-scope .tw-h-2\\.5 {
    height: 0.625rem;
}
.project-notes-scope .tw-h-3 {
    height: 0.75rem;
}
.project-notes-scope .tw-h-3\\.5 {
    height: 0.875rem;
}
.project-notes-scope .tw-h-4 {
    height: 1rem;
}
.project-notes-scope .tw-h-5 {
    height: 1.25rem;
}
.project-notes-scope .tw-h-6 {
    height: 1.5rem;
}
.project-notes-scope .tw-h-7 {
    height: 1.75rem;
}
.project-notes-scope .tw-h-8 {
    height: 2rem;
}
.project-notes-scope .tw-h-80 {
    height: 20rem;
}
.project-notes-scope .tw-h-9 {
    height: 2.25rem;
}
.project-notes-scope .tw-h-\\[7px\\] {
    height: 7px;
}
.project-notes-scope .tw-h-full {
    height: 100%;
}
.project-notes-scope .tw-h-px {
    height: 1px;
}
.project-notes-scope .tw-max-h-60 {
    max-height: 15rem;
}
.project-notes-scope .tw-max-h-\\[calc\\(100vh-5rem\\)\\] {
    max-height: calc(100vh - 5rem);
}
.project-notes-scope .tw-min-h-0 {
    min-height: 0px;
}
.project-notes-scope .tw-min-h-7 {
    min-height: 1.75rem;
}
.project-notes-scope .tw-min-h-\\[180px\\] {
    min-height: 180px;
}
.project-notes-scope .tw-min-h-\\[44px\\] {
    min-height: 44px;
}
.project-notes-scope .tw-w-10 {
    width: 2.5rem;
}
.project-notes-scope .tw-w-11 {
    width: 2.75rem;
}
.project-notes-scope .tw-w-2 {
    width: 0.5rem;
}
.project-notes-scope .tw-w-2\\.5 {
    width: 0.625rem;
}
.project-notes-scope .tw-w-3 {
    width: 0.75rem;
}
.project-notes-scope .tw-w-3\\.5 {
    width: 0.875rem;
}
.project-notes-scope .tw-w-4 {
    width: 1rem;
}
.project-notes-scope .tw-w-5 {
    width: 1.25rem;
}
.project-notes-scope .tw-w-56 {
    width: 14rem;
}
.project-notes-scope .tw-w-6 {
    width: 1.5rem;
}
.project-notes-scope .tw-w-7 {
    width: 1.75rem;
}
.project-notes-scope .tw-w-8 {
    width: 2rem;
}
.project-notes-scope .tw-w-\\[7px\\] {
    width: 7px;
}
.project-notes-scope .tw-w-fit {
    width: -moz-fit-content;
    width: fit-content;
}
.project-notes-scope .tw-w-full {
    width: 100%;
}
.project-notes-scope .tw-w-px {
    width: 1px;
}
.project-notes-scope .tw-min-w-0 {
    min-width: 0px;
}
.project-notes-scope .tw-min-w-\\[340px\\] {
    min-width: 340px;
}
.project-notes-scope .tw-min-w-\\[80px\\] {
    min-width: 80px;
}
.project-notes-scope .tw-max-w-2xl {
    max-width: 42rem;
}
.project-notes-scope .tw-max-w-5xl {
    max-width: 64rem;
}
.project-notes-scope .tw-max-w-\\[140px\\] {
    max-width: 140px;
}
.project-notes-scope .tw-max-w-\\[35rem\\] {
    max-width: 35rem;
}
.project-notes-scope .tw-max-w-\\[800px\\] {
    max-width: 800px;
}
.project-notes-scope .tw-max-w-\\[95vw\\] {
    max-width: 95vw;
}
.project-notes-scope .tw-max-w-full {
    max-width: 100%;
}
.project-notes-scope .tw-max-w-md {
    max-width: 28rem;
}
.project-notes-scope .tw-max-w-xs {
    max-width: 20rem;
}
.project-notes-scope .tw-flex-1 {
    flex: 1 1 0%;
}
.project-notes-scope .tw-flex-none {
    flex: none;
}
.project-notes-scope .tw-flex-shrink-0 {
    flex-shrink: 0;
}
.project-notes-scope .tw-shrink-0 {
    flex-shrink: 0;
}
.project-notes-scope .tw-border-collapse {
    border-collapse: collapse;
}
.project-notes-scope .-tw-translate-x-1\\/2 {
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes tw-narration-blink {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.45;
    }
}
.project-notes-scope .tw-animate-narration-blink {
    animation: tw-narration-blink 1.3s ease-in-out infinite;
}
@keyframes tw-pulse {
    50% {
        opacity: .5;
    }
}
.project-notes-scope .tw-animate-pulse {
    animation: tw-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes tw-spin {
    to {
        transform: rotate(360deg);
    }
}
.project-notes-scope .tw-animate-spin {
    animation: tw-spin 1s linear infinite;
}
.project-notes-scope .tw-cursor-grab {
    cursor: grab;
}
.project-notes-scope .tw-cursor-nw-resize {
    cursor: nw-resize;
}
.project-notes-scope .tw-cursor-pointer {
    cursor: pointer;
}
.project-notes-scope .tw-cursor-text {
    cursor: text;
}
.project-notes-scope .tw-select-none {
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
}
.project-notes-scope .tw-resize-y {
    resize: vertical;
}
.project-notes-scope .tw-list-disc {
    list-style-type: disc;
}
.project-notes-scope .tw-list-none {
    list-style-type: none;
}
.project-notes-scope .tw-appearance-none {
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
}
.project-notes-scope .tw-grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
}
.project-notes-scope .tw-grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}
.project-notes-scope .tw-flex-col {
    flex-direction: column;
}
.project-notes-scope .tw-flex-wrap {
    flex-wrap: wrap;
}
.project-notes-scope .tw-flex-nowrap {
    flex-wrap: nowrap;
}
.project-notes-scope .tw-items-start {
    align-items: flex-start;
}
.project-notes-scope .tw-items-end {
    align-items: flex-end;
}
.project-notes-scope .tw-items-center {
    align-items: center;
}
.project-notes-scope .tw-items-baseline {
    align-items: baseline;
}
.project-notes-scope .tw-items-stretch {
    align-items: stretch;
}
.project-notes-scope .tw-justify-end {
    justify-content: flex-end;
}
.project-notes-scope .tw-justify-center {
    justify-content: center;
}
.project-notes-scope .tw-justify-between {
    justify-content: space-between;
}
.project-notes-scope .tw-gap-0\\.5 {
    gap: 0.125rem;
}
.project-notes-scope .tw-gap-1 {
    gap: 0.25rem;
}
.project-notes-scope .tw-gap-1\\.5 {
    gap: 0.375rem;
}
.project-notes-scope .tw-gap-2 {
    gap: 0.5rem;
}
.project-notes-scope .tw-gap-2\\.5 {
    gap: 0.625rem;
}
.project-notes-scope .tw-gap-3 {
    gap: 0.75rem;
}
.project-notes-scope .tw-gap-4 {
    gap: 1rem;
}
.project-notes-scope .tw-gap-5 {
    gap: 1.25rem;
}
.project-notes-scope .tw-gap-6 {
    gap: 1.5rem;
}
.project-notes-scope .tw-gap-8 {
    gap: 2rem;
}
.project-notes-scope .tw-gap-x-1\\.5 {
    -moz-column-gap: 0.375rem;
         column-gap: 0.375rem;
}
.project-notes-scope .tw-gap-x-2 {
    -moz-column-gap: 0.5rem;
         column-gap: 0.5rem;
}
.project-notes-scope .tw-gap-x-2\\.5 {
    -moz-column-gap: 0.625rem;
         column-gap: 0.625rem;
}
.project-notes-scope .tw-gap-x-4 {
    -moz-column-gap: 1rem;
         column-gap: 1rem;
}
.project-notes-scope .tw-gap-y-1 {
    row-gap: 0.25rem;
}
.project-notes-scope .tw-gap-y-1\\.5 {
    row-gap: 0.375rem;
}
.project-notes-scope :is(.tw-space-x-2\\.5 > :not([hidden]) ~ :not([hidden])) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.625rem * var(--tw-space-x-reverse));
    margin-left: calc(0.625rem * calc(1 - var(--tw-space-x-reverse)));
}
.project-notes-scope :is(.tw-space-x-3 > :not([hidden]) ~ :not([hidden])) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.project-notes-scope :is(.tw-space-y-1\\.5 > :not([hidden]) ~ :not([hidden])) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.project-notes-scope :is(.tw-space-y-2\\.5 > :not([hidden]) ~ :not([hidden])) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.project-notes-scope :is(.tw-space-y-3 > :not([hidden]) ~ :not([hidden])) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.project-notes-scope .tw-self-center {
    align-self: center;
}
.project-notes-scope .tw-self-stretch {
    align-self: stretch;
}
.project-notes-scope .tw-overflow-hidden {
    overflow: hidden;
}
.project-notes-scope .tw-overflow-visible {
    overflow: visible;
}
.project-notes-scope .tw-overflow-x-auto {
    overflow-x: auto;
}
.project-notes-scope .tw-overflow-y-auto {
    overflow-y: auto;
}
.project-notes-scope .tw-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.project-notes-scope .tw-whitespace-nowrap {
    white-space: nowrap;
}
.project-notes-scope .tw-whitespace-pre-wrap {
    white-space: pre-wrap;
}
.project-notes-scope .tw-rounded {
    border-radius: 0.25rem;
}
.project-notes-scope .tw-rounded-2xl {
    border-radius: 1rem;
}
.project-notes-scope .tw-rounded-full {
    border-radius: 9999px;
}
.project-notes-scope .tw-rounded-lg {
    border-radius: 0.5rem;
}
.project-notes-scope .tw-rounded-md {
    border-radius: 0.375rem;
}
.project-notes-scope .tw-rounded-xl {
    border-radius: 0.75rem;
}
.project-notes-scope .tw-border {
    border-width: 1px;
}
.project-notes-scope .tw-border-0 {
    border-width: 0px;
}
.project-notes-scope .tw-border-2 {
    border-width: 2px;
}
.project-notes-scope .tw-border-b {
    border-bottom-width: 1px;
}
.project-notes-scope .tw-border-l-0 {
    border-left-width: 0px;
}
.project-notes-scope .tw-border-l-4 {
    border-left-width: 4px;
}
.project-notes-scope .tw-border-r-0 {
    border-right-width: 0px;
}
.project-notes-scope .tw-border-t {
    border-top-width: 1px;
}
.project-notes-scope .tw-border-t-0 {
    border-top-width: 0px;
}
.project-notes-scope .tw-border-solid {
    border-style: solid;
}
.project-notes-scope .tw-border-dashed {
    border-style: dashed;
}
.project-notes-scope .tw-border-\\[\\#0089e0\\] {
    --tw-border-opacity: 1;
    border-color: rgb(0 137 224 / var(--tw-border-opacity, 1));
}
.project-notes-scope .tw-border-\\[\\#15734d\\] {
    --tw-border-opacity: 1;
    border-color: rgb(21 115 77 / var(--tw-border-opacity, 1));
}
.project-notes-scope .tw-border-\\[\\#30363d\\] {
    --tw-border-opacity: 1;
    border-color: rgb(48 54 61 / var(--tw-border-opacity, 1));
}
.project-notes-scope .tw-border-\\[\\#5063b5\\] {
    --tw-border-opacity: 1;
    border-color: rgb(80 99 181 / var(--tw-border-opacity, 1));
}
.project-notes-scope .tw-border-\\[\\#5063b5\\]\\/50 {
    border-color: rgb(80 99 181 / 0.5);
}
.project-notes-scope .tw-border-\\[var\\(--pill-accent\\)\\] {
    border-color: var(--pill-accent);
}
.project-notes-scope .tw-border-amber-500 {
    --tw-border-opacity: 1;
    border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.project-notes-scope .tw-border-border {
    border-color: var(--border);
}
.project-notes-scope .tw-border-destructive {
    border-color: var(--destructive);
}
.project-notes-scope .tw-border-gray-200 {
    --tw-border-opacity: 1;
    border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.project-notes-scope .tw-border-gray-200\\/80 {
    border-color: rgb(229 231 235 / 0.8);
}
.project-notes-scope .tw-border-input {
    border-color: var(--input);
}
.project-notes-scope .tw-border-neutral-200 {
    --tw-border-opacity: 1;
    border-color: rgb(229 229 229 / var(--tw-border-opacity, 1));
}
.project-notes-scope .tw-border-neutral-300 {
    --tw-border-opacity: 1;
    border-color: rgb(212 212 212 / var(--tw-border-opacity, 1));
}
.project-notes-scope .tw-border-primary {
    border-color: var(--primary);
}
.project-notes-scope .tw-border-red-300 {
    --tw-border-opacity: 1;
    border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.project-notes-scope .tw-border-success {
    border-color: var(--success);
}
.project-notes-scope .tw-border-transparent {
    border-color: transparent;
}
.project-notes-scope .tw-bg-\\[\\#0089e0\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(0 137 224 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .tw-bg-\\[\\#0089e0\\]\\/10 {
    background-color: rgb(0 137 224 / 0.1);
}
.project-notes-scope .tw-bg-\\[\\#15734d\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(21 115 77 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .tw-bg-\\[\\#161b22\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(22 27 34 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .tw-bg-\\[\\#5063b5\\]\\/10 {
    background-color: rgb(80 99 181 / 0.1);
}
.project-notes-scope .tw-bg-\\[\\#f0ecec\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(240 236 236 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .tw-bg-\\[rgb\\(var\\(--pill-accent-rgb\\)\\/0\\.1\\)\\] {
    background-color: rgb(var(--pill-accent-rgb)/0.1);
}
.project-notes-scope .tw-bg-\\[rgb\\(var\\(--pill-accent-rgb\\)\\/0\\.15\\)\\] {
    background-color: rgb(var(--pill-accent-rgb)/0.15);
}
.project-notes-scope .tw-bg-\\[rgb\\(var\\(--pill-accent-rgb\\)\\/0\\.25\\)\\] {
    background-color: rgb(var(--pill-accent-rgb)/0.25);
}
.project-notes-scope .tw-bg-\\[var\\(\\\$\\{name\\}\\)\\] {
    background-color: var(\${name});
}
.project-notes-scope .tw-bg-\\[var\\(--ai-buttons-color-strong\\)\\] {
    background-color: var(--ai-buttons-color-strong);
}
.project-notes-scope .tw-bg-\\[var\\(--pill-accent\\)\\] {
    background-color: var(--pill-accent);
}
.project-notes-scope .tw-bg-amber-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .tw-bg-background {
    background-color: var(--background);
}
.project-notes-scope .tw-bg-black\\/20 {
    background-color: rgb(0 0 0 / 0.2);
}
.project-notes-scope .tw-bg-black\\/50 {
    background-color: rgb(0 0 0 / 0.5);
}
.project-notes-scope .tw-bg-border {
    background-color: var(--border);
}
.project-notes-scope .tw-bg-card {
    background-color: var(--card);
}
.project-notes-scope .tw-bg-destructive {
    background-color: var(--destructive);
}
.project-notes-scope .tw-bg-gray-300\\/80 {
    background-color: rgb(209 213 219 / 0.8);
}
.project-notes-scope .tw-bg-muted {
    background-color: var(--muted);
}
.project-notes-scope .tw-bg-neutral-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .tw-bg-neutral-100\\/60 {
    background-color: rgb(245 245 245 / 0.6);
}
.project-notes-scope .tw-bg-neutral-200 {
    --tw-bg-opacity: 1;
    background-color: rgb(229 229 229 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .tw-bg-neutral-200\\/60 {
    background-color: rgb(229 229 229 / 0.6);
}
.project-notes-scope .tw-bg-neutral-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .tw-bg-neutral-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(38 38 38 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .tw-bg-primary {
    background-color: var(--primary);
}
.project-notes-scope .tw-bg-red-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .tw-bg-secondary {
    background-color: var(--secondary);
}
.project-notes-scope .tw-bg-success {
    background-color: var(--success);
}
.project-notes-scope .tw-bg-transparent {
    background-color: transparent;
}
.project-notes-scope .tw-bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .tw-bg-white\\/90 {
    background-color: rgb(255 255 255 / 0.9);
}
.project-notes-scope .tw-bg-clip-padding {
    background-clip: padding-box;
}
.project-notes-scope .tw-p-0 {
    padding: 0px;
}
.project-notes-scope .tw-p-1 {
    padding: 0.25rem;
}
.project-notes-scope .tw-p-1\\.5 {
    padding: 0.375rem;
}
.project-notes-scope .tw-p-2 {
    padding: 0.5rem;
}
.project-notes-scope .tw-p-2\\.5 {
    padding: 0.625rem;
}
.project-notes-scope .tw-p-3 {
    padding: 0.75rem;
}
.project-notes-scope .tw-p-4 {
    padding: 1rem;
}
.project-notes-scope .tw-p-5 {
    padding: 1.25rem;
}
.project-notes-scope .tw-p-6 {
    padding: 1.5rem;
}
.project-notes-scope .tw-px-0\\.5 {
    padding-left: 0.125rem;
    padding-right: 0.125rem;
}
.project-notes-scope .tw-px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
}
.project-notes-scope .tw-px-1\\.5 {
    padding-left: 0.375rem;
    padding-right: 0.375rem;
}
.project-notes-scope .tw-px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}
.project-notes-scope .tw-px-2\\.5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
}
.project-notes-scope .tw-px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
}
.project-notes-scope .tw-px-3\\.5 {
    padding-left: 0.875rem;
    padding-right: 0.875rem;
}
.project-notes-scope .tw-px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
}
.project-notes-scope .tw-px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
}
.project-notes-scope .tw-px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}
.project-notes-scope .tw-py-0\\.5 {
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
}
.project-notes-scope .tw-py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}
.project-notes-scope .tw-py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
}
.project-notes-scope .tw-py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.project-notes-scope .tw-py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
}
.project-notes-scope .tw-py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
}
.project-notes-scope .tw-pb-2 {
    padding-bottom: 0.5rem;
}
.project-notes-scope .tw-pb-3 {
    padding-bottom: 0.75rem;
}
.project-notes-scope .tw-pl-2\\.5 {
    padding-left: 0.625rem;
}
.project-notes-scope .tw-pl-3 {
    padding-left: 0.75rem;
}
.project-notes-scope .tw-pl-4 {
    padding-left: 1rem;
}
.project-notes-scope .tw-pl-5 {
    padding-left: 1.25rem;
}
.project-notes-scope .tw-pl-\\[22px\\] {
    padding-left: 22px;
}
.project-notes-scope .tw-pr-11 {
    padding-right: 2.75rem;
}
.project-notes-scope .tw-pr-2 {
    padding-right: 0.5rem;
}
.project-notes-scope .tw-pr-3\\.5 {
    padding-right: 0.875rem;
}
.project-notes-scope .tw-pr-9 {
    padding-right: 2.25rem;
}
.project-notes-scope .tw-pt-2 {
    padding-top: 0.5rem;
}
.project-notes-scope .tw-pt-2\\.5 {
    padding-top: 0.625rem;
}
.project-notes-scope .tw-pt-3 {
    padding-top: 0.75rem;
}
.project-notes-scope .tw-pt-4 {
    padding-top: 1rem;
}
.project-notes-scope .tw-text-left {
    text-align: left;
}
.project-notes-scope .tw-text-center {
    text-align: center;
}
.project-notes-scope .tw-font-\\[inherit\\] {
    font-family: inherit;
}
.project-notes-scope .tw-font-mono {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.project-notes-scope .tw-text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
}
.project-notes-scope .tw-text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
}
.project-notes-scope .tw-text-\\[0\\.8rem\\] {
    font-size: 0.8rem;
}
.project-notes-scope .tw-text-\\[10\\.5px\\] {
    font-size: 10.5px;
}
.project-notes-scope .tw-text-\\[10px\\] {
    font-size: 10px;
}
.project-notes-scope .tw-text-\\[11\\.5px\\] {
    font-size: 11.5px;
}
.project-notes-scope .tw-text-\\[12\\.5px\\] {
    font-size: 12.5px;
}
.project-notes-scope .tw-text-\\[12px\\] {
    font-size: 12px;
}
.project-notes-scope .tw-text-\\[13px\\] {
    font-size: 13px;
}
.project-notes-scope .tw-text-\\[14px\\] {
    font-size: 14px;
}
.project-notes-scope .tw-text-\\[17px\\] {
    font-size: 17px;
}
.project-notes-scope .tw-text-base {
    font-size: 1rem;
    line-height: 1.5rem;
}
.project-notes-scope .tw-text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
}
.project-notes-scope .tw-text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
}
.project-notes-scope .tw-text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
}
.project-notes-scope .tw-text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
}
.project-notes-scope .tw-font-bold {
    font-weight: 700;
}
.project-notes-scope .tw-font-medium {
    font-weight: 500;
}
.project-notes-scope .tw-font-normal {
    font-weight: 400;
}
.project-notes-scope .tw-font-semibold {
    font-weight: 600;
}
.project-notes-scope .tw-uppercase {
    text-transform: uppercase;
}
.project-notes-scope .tw-normal-case {
    text-transform: none;
}
.project-notes-scope .tw-tabular-nums {
    --tw-numeric-spacing: tabular-nums;
    font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.project-notes-scope .tw-leading-none {
    line-height: 1;
}
.project-notes-scope .tw-leading-relaxed {
    line-height: 1.625;
}
.project-notes-scope .tw-leading-snug {
    line-height: 1.375;
}
.project-notes-scope .tw-tracking-normal {
    letter-spacing: 0em;
}
.project-notes-scope .tw-tracking-tight {
    letter-spacing: -0.025em;
}
.project-notes-scope .tw-tracking-wide {
    letter-spacing: 0.025em;
}
.project-notes-scope .tw-tracking-wider {
    letter-spacing: 0.05em;
}
.project-notes-scope .tw-text-\\[\\#0089e0\\] {
    --tw-text-opacity: 1;
    color: rgb(0 137 224 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-\\[\\#15734d\\] {
    --tw-text-opacity: 1;
    color: rgb(21 115 77 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-\\[\\#3c4043\\] {
    --tw-text-opacity: 1;
    color: rgb(60 64 67 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-\\[\\#5063b5\\] {
    --tw-text-opacity: 1;
    color: rgb(80 99 181 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-\\[\\#525252\\] {
    --tw-text-opacity: 1;
    color: rgb(82 82 82 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-\\[\\#e6edf3\\] {
    --tw-text-opacity: 1;
    color: rgb(230 237 243 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-\\[var\\(--pill-accent\\)\\] {
    color: var(--pill-accent);
}
.project-notes-scope .tw-text-amber-700 {
    --tw-text-opacity: 1;
    color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-amber-900 {
    --tw-text-opacity: 1;
    color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-blue-600 {
    --tw-text-opacity: 1;
    color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-card-foreground {
    color: var(--card-foreground);
}
.project-notes-scope .tw-text-destructive {
    color: var(--destructive);
}
.project-notes-scope .tw-text-destructive-foreground {
    color: var(--destructive-foreground);
}
.project-notes-scope .tw-text-foreground {
    color: var(--foreground);
}
.project-notes-scope .tw-text-gray-700 {
    --tw-text-opacity: 1;
    color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-muted-foreground {
    color: var(--muted-foreground);
}
.project-notes-scope .tw-text-neutral-300 {
    --tw-text-opacity: 1;
    color: rgb(212 212 212 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-neutral-400 {
    --tw-text-opacity: 1;
    color: rgb(163 163 163 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-neutral-500 {
    --tw-text-opacity: 1;
    color: rgb(115 115 115 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-neutral-600 {
    --tw-text-opacity: 1;
    color: rgb(82 82 82 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-neutral-700 {
    --tw-text-opacity: 1;
    color: rgb(64 64 64 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-neutral-800 {
    --tw-text-opacity: 1;
    color: rgb(38 38 38 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-neutral-900 {
    --tw-text-opacity: 1;
    color: rgb(23 23 23 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-primary {
    color: var(--primary);
}
.project-notes-scope .tw-text-primary-foreground {
    color: var(--primary-foreground);
}
.project-notes-scope .tw-text-red-400 {
    --tw-text-opacity: 1;
    color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-red-500 {
    --tw-text-opacity: 1;
    color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-text-secondary-foreground {
    color: var(--secondary-foreground);
}
.project-notes-scope .tw-text-success {
    color: var(--success);
}
.project-notes-scope .tw-text-success-foreground {
    color: var(--success-foreground);
}
.project-notes-scope .tw-text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.project-notes-scope .tw-underline {
    text-decoration-line: underline;
}
.project-notes-scope .tw-no-underline {
    text-decoration-line: none;
}
.project-notes-scope .tw-underline-offset-2 {
    text-underline-offset: 2px;
}
.project-notes-scope .tw-underline-offset-4 {
    text-underline-offset: 4px;
}
.project-notes-scope .tw-opacity-0 {
    opacity: 0;
}
.project-notes-scope .tw-opacity-100 {
    opacity: 1;
}
.project-notes-scope .tw-opacity-50 {
    opacity: 0.5;
}
.project-notes-scope .tw-opacity-60 {
    opacity: 0.6;
}
.project-notes-scope .tw-opacity-90 {
    opacity: 0.9;
}
.project-notes-scope .tw-shadow-2xl {
    --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
    --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.project-notes-scope .tw-shadow-lg {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.project-notes-scope .tw-shadow-md {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.project-notes-scope .tw-shadow-sm {
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.project-notes-scope .tw-shadow-xl {
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.project-notes-scope .tw-shadow-black\\/10 {
    --tw-shadow-color: rgb(0 0 0 / 0.1);
    --tw-shadow: var(--tw-shadow-colored);
}
.project-notes-scope .tw-outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px;
}
.project-notes-scope .tw-backdrop-blur-md {
    --tw-backdrop-blur: blur(12px);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.project-notes-scope .tw-transition-all {
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.project-notes-scope .tw-transition-colors {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.project-notes-scope .tw-transition-opacity {
    transition-property: opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.project-notes-scope .tw-duration-200 {
    transition-duration: 200ms;
}
.project-notes-scope .tw-duration-300 {
    transition-duration: 300ms;
}

/*
 * Semantic color tokens for the ui/ component library (Button, Badge, etc.).
 * These map the tw-bg-primary, tw-text-foreground, tw-bg-muted etc. classes
 * that CVA variants reference. Without these, those classes resolve to nothing
 * since we omitted @tailwind base.
 */
.project-notes-scope {
    --background: #ffffff;
    --foreground: #171717;
    /* Raised surface: dialogs, plan cards, the auth card. In light it matches
       the page and separates via border + shadow; in dark it must sit above
       the page, which is why the two values are not symmetric. */
    --card: #ffffff;
    --card-foreground: #171717;
    --primary: #171717;
    --primary-foreground: #fafafa;
    --secondary: #f5f5f5;
    --secondary-foreground: #171717;
    --muted: #f5f5f5;
    --muted-foreground: #737373;
    --destructive: #ef4444;
    --destructive-foreground: #fafafa;
    /* The comparison table's "included" green (PricingComparisonModal). */
    --success: #22c55e;
    --success-foreground: #ffffff;
    --border: #e5e5e5;
    --input: #e5e5e5;
    --ring: #a3a3a3;
}

.tw-dark .project-notes-scope {
    --background: #171717;
    --foreground: #fafafa;
    --card: #1f1f1f;
    --card-foreground: #fafafa;
    --primary: #fafafa;
    --primary-foreground: #171717;
    --secondary: #262626;
    --secondary-foreground: #fafafa;
    --muted: #262626;
    --muted-foreground: #a3a3a3;
    --destructive: #dc2626;
    --destructive-foreground: #fafafa;
    --success: #4ade80;
    --success-foreground: #171717;
    --border: #404040;
    --input: #404040;
    --ring: #525252;
}

/*
 * Reset global button{} styles from style.css within our scope. The auth pages
 * sit in the marketing theme instead and keep its .btn; :where() excludes them
 * without raising the reset's specificity above the utilities. Payment buttons
 * drawn by Google/Apple (.cb-wallets) are excluded too: unset, Google Pay's
 * button collapses to zero height.
 * The Tailwind utilities have higher specificity via
 * important: '.project-notes-scope' in tailwind.config.js,
 * so they override this reset cleanly.
 */
.project-notes-scope:where(:not(.auth-page)) button:where(:not(.cb-wallets *)) {
    all: unset;
    cursor: pointer;
    box-sizing: border-box;
}

/*
 * Legacy Project Notes trigger — hidden in favor of the React PanelToggles.
 * The element stays in DOM because legacyBridge.js relies on it being there
 * when re-stubbing window.getGraphInfoToggle. We use !important because the
 * tooltipster jQuery plugin clears inline \`style="display:none"\` after init.
 */
#info-link {
    display: none !important;
}

/*
 * Chargebee card fields (/upgrade). The inputs themselves live in Chargebee
 * iframes, so the only styling the app controls is the box around them plus
 * the classes Chargebee toggles on that box (useChargebeeCheckout.js).
 */
.project-notes-scope .cb-field {
    /* Chargebee's inputs paint themselves white and expose no background in
       their style API, so the box around them is light in both themes and the
       text colour handed to Chargebee is dark to match
       (useChargebeeCheckout.js). */
    background: #ffffff;
    border-color: #d4d4d8;
    transition: border-color 120ms ease, box-shadow 120ms ease;
}
.project-notes-scope .cb-field.is-focus {
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.25);
}
.project-notes-scope .cb-field.is-invalid {
    border-color: var(--destructive);
}

/*
 * One shape for the three providers' payment buttons. Iframes keep a light
 * colour scheme: on dark pages Chromium paints an opaque backdrop behind them
 * (white corners around PayPal). The element selector outranks Google's
 * later-injected .gpay-button rules.
 */
.project-notes-scope .cb-wallets > [id^='cb-wallet-'] {
    height: 45px;
    border-radius: 4px;
    overflow: hidden;
    transition: opacity 0.15s ease;
}
.project-notes-scope .cb-wallets > [id^='cb-wallet-']:hover {
    opacity: 0.85;
}
.project-notes-scope .cb-wallets iframe {
    color-scheme: light;
}
.project-notes-scope .cb-wallets button.gpay-button,
.project-notes-scope .cb-wallets button.gpay-button:hover,
.project-notes-scope .cb-wallets button.gpay-button:focus {
    display: block;
    width: 100%;
    min-width: 0;
    height: 45px;
    min-height: 45px;
    border: 0;
    border-radius: 0;
    box-shadow: none;
    outline: none;
    background-color: #000;
    box-sizing: border-box;
}
.project-notes-scope .cb-wallets #cb-wallet-apple-pay {
    --apple-pay-button-width: 100%;
    --apple-pay-button-height: 45px;
    --apple-pay-button-border-radius: 0;
}
.project-notes-scope .placeholder\\:tw-text-neutral-400::-moz-placeholder {
    --tw-text-opacity: 1;
    color: rgb(163 163 163 / var(--tw-text-opacity, 1));
}
.project-notes-scope .placeholder\\:tw-text-neutral-400::placeholder {
    --tw-text-opacity: 1;
    color: rgb(163 163 163 / var(--tw-text-opacity, 1));
}
.project-notes-scope .first\\:tw-border-t-0:first-child {
    border-top-width: 0px;
}
.project-notes-scope .focus-within\\:tw-border-neutral-400:focus-within {
    --tw-border-opacity: 1;
    border-color: rgb(163 163 163 / var(--tw-border-opacity, 1));
}
.project-notes-scope .focus-within\\:tw-ring-1:focus-within {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.project-notes-scope .focus-within\\:tw-ring-neutral-300\\/50:focus-within {
    --tw-ring-color: rgb(212 212 212 / 0.5);
}
.project-notes-scope .hover\\:tw-border-\\[\\#0089e0\\]:hover {
    --tw-border-opacity: 1;
    border-color: rgb(0 137 224 / var(--tw-border-opacity, 1));
}
.project-notes-scope .hover\\:tw-border-\\[\\#105c3d\\]:hover {
    --tw-border-opacity: 1;
    border-color: rgb(16 92 61 / var(--tw-border-opacity, 1));
}
.project-notes-scope .hover\\:tw-border-\\[rgba\\(35\\2c 131\\2c 226\\2c 0\\.4\\)\\]:hover {
    border-color: rgba(35,131,226,0.4);
}
.project-notes-scope .hover\\:tw-border-\\[var\\(--pill-accent\\)\\]:hover {
    border-color: var(--pill-accent);
}
.project-notes-scope .hover\\:tw-border-muted-foreground:hover {
    border-color: var(--muted-foreground);
}
.project-notes-scope .hover\\:tw-border-neutral-400:hover {
    --tw-border-opacity: 1;
    border-color: rgb(163 163 163 / var(--tw-border-opacity, 1));
}
.project-notes-scope .hover\\:tw-bg-\\[\\#0089e0\\]\\/10:hover {
    background-color: rgb(0 137 224 / 0.1);
}
.project-notes-scope .hover\\:tw-bg-\\[\\#105c3d\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(16 92 61 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .hover\\:tw-bg-\\[\\#21262d\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(33 38 45 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .hover\\:tw-bg-\\[\\#5063b5\\]\\/10:hover {
    background-color: rgb(80 99 181 / 0.1);
}
.project-notes-scope .hover\\:tw-bg-\\[rgba\\(35\\2c 131\\2c 226\\2c 0\\.2\\)\\]:hover {
    background-color: rgba(35,131,226,0.2);
}
.project-notes-scope .hover\\:tw-bg-gray-100\\/80:hover {
    background-color: rgb(243 244 246 / 0.8);
}
.project-notes-scope .hover\\:tw-bg-muted:hover {
    background-color: var(--muted);
}
.project-notes-scope .hover\\:tw-bg-neutral-100:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .hover\\:tw-bg-neutral-200\\/70:hover {
    background-color: rgb(229 229 229 / 0.7);
}
.project-notes-scope .hover\\:tw-bg-neutral-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(64 64 64 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .hover\\:tw-text-\\[\\#e6edf3\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(230 237 243 / var(--tw-text-opacity, 1));
}
.project-notes-scope .hover\\:tw-text-\\[rgb\\(35\\2c 131\\2c 226\\)\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(35 131 226 / var(--tw-text-opacity, 1));
}
.project-notes-scope .hover\\:tw-text-foreground:hover {
    color: var(--foreground);
}
.project-notes-scope .hover\\:tw-text-neutral-700:hover {
    --tw-text-opacity: 1;
    color: rgb(64 64 64 / var(--tw-text-opacity, 1));
}
.project-notes-scope .hover\\:tw-underline:hover {
    text-decoration-line: underline;
}
.project-notes-scope .focus\\:tw-outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
}
.project-notes-scope .focus\\:tw-ring-2:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.project-notes-scope .focus\\:tw-ring-\\[3px\\]:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.project-notes-scope .focus\\:tw-ring-ring:focus {
    --tw-ring-color: var(--ring);
}
.project-notes-scope .focus-visible\\:tw-border-ring:focus-visible {
    border-color: var(--ring);
}
.project-notes-scope .focus-visible\\:tw-outline:focus-visible {
    outline-style: solid;
}
.project-notes-scope .focus-visible\\:tw-outline-2:focus-visible {
    outline-width: 2px;
}
.project-notes-scope .focus-visible\\:tw-outline-offset-2:focus-visible {
    outline-offset: 2px;
}
.project-notes-scope .focus-visible\\:tw-outline-\\[var\\(--pill-accent\\)\\]:focus-visible {
    outline-color: var(--pill-accent);
}
.project-notes-scope .focus-visible\\:tw-ring-\\[3px\\]:focus-visible {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.project-notes-scope .active\\:tw-translate-y-px:active {
    --tw-translate-y: 1px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.project-notes-scope .active\\:tw-cursor-grabbing:active {
    cursor: grabbing;
}
.project-notes-scope .disabled\\:tw-pointer-events-none:disabled {
    pointer-events: none;
}
.project-notes-scope .disabled\\:tw-cursor-default:disabled {
    cursor: default;
}
.project-notes-scope .disabled\\:tw-cursor-not-allowed:disabled {
    cursor: not-allowed;
}
.project-notes-scope .disabled\\:tw-text-muted-foreground:disabled {
    color: var(--muted-foreground);
}
.project-notes-scope .disabled\\:tw-opacity-30:disabled {
    opacity: 0.3;
}
.project-notes-scope .disabled\\:tw-opacity-50:disabled {
    opacity: 0.5;
}
.project-notes-scope .disabled\\:tw-opacity-60:disabled {
    opacity: 0.6;
}
.project-notes-scope :is(.tw-group:hover .group-hover\\:tw-bg-neutral-200) {
    --tw-bg-opacity: 1;
    background-color: rgb(229 229 229 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .has-\\[\\[data-icon\\=inline-end\\]\\]\\:tw-pr-1\\.5:has([data-icon=inline-end]) {
    padding-right: 0.375rem;
}
.project-notes-scope .has-\\[\\[data-icon\\=inline-end\\]\\]\\:tw-pr-2:has([data-icon=inline-end]) {
    padding-right: 0.5rem;
}
.project-notes-scope .has-\\[\\[data-icon\\=inline-end\\]\\]\\:tw-pr-3:has([data-icon=inline-end]) {
    padding-right: 0.75rem;
}
.project-notes-scope .has-\\[\\[data-icon\\=inline-start\\]\\]\\:tw-pl-1\\.5:has([data-icon=inline-start]) {
    padding-left: 0.375rem;
}
.project-notes-scope .has-\\[\\[data-icon\\=inline-start\\]\\]\\:tw-pl-2:has([data-icon=inline-start]) {
    padding-left: 0.5rem;
}
.project-notes-scope .has-\\[\\[data-icon\\=inline-start\\]\\]\\:tw-pl-3:has([data-icon=inline-start]) {
    padding-left: 0.75rem;
}
.project-notes-scope :is(.tw-group:has(button) .group-has-\\[button\\]\\:tw-flex) {
    display: flex;
}
.project-notes-scope :is(.tw-group:has(iframe) .group-has-\\[iframe\\]\\:tw-flex) {
    display: flex;
}
.project-notes-scope .dark\\:tw-border-\\[\\#00b7ff\\]:is(.tw-dark *) {
    --tw-border-opacity: 1;
    border-color: rgb(0 183 255 / var(--tw-border-opacity, 1));
}
.project-notes-scope .dark\\:tw-border-\\[\\#33c686\\]:is(.tw-dark *) {
    --tw-border-opacity: 1;
    border-color: rgb(51 198 134 / var(--tw-border-opacity, 1));
}
.project-notes-scope .dark\\:tw-border-\\[\\#b7c5ff\\]:is(.tw-dark *) {
    --tw-border-opacity: 1;
    border-color: rgb(183 197 255 / var(--tw-border-opacity, 1));
}
.project-notes-scope .dark\\:tw-border-\\[\\#b7c5ff\\]\\/50:is(.tw-dark *) {
    border-color: rgb(183 197 255 / 0.5);
}
.project-notes-scope .dark\\:tw-border-gray-700:is(.tw-dark *) {
    --tw-border-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.project-notes-scope .dark\\:tw-border-gray-700\\/60:is(.tw-dark *) {
    border-color: rgb(55 65 81 / 0.6);
}
.project-notes-scope .dark\\:tw-border-input:is(.tw-dark *) {
    border-color: var(--input);
}
.project-notes-scope .dark\\:tw-border-neutral-600:is(.tw-dark *) {
    --tw-border-opacity: 1;
    border-color: rgb(82 82 82 / var(--tw-border-opacity, 1));
}
.project-notes-scope .dark\\:tw-border-neutral-600\\/50:is(.tw-dark *) {
    border-color: rgb(82 82 82 / 0.5);
}
.project-notes-scope .dark\\:tw-border-neutral-700:is(.tw-dark *) {
    --tw-border-opacity: 1;
    border-color: rgb(64 64 64 / var(--tw-border-opacity, 1));
}
.project-notes-scope .dark\\:tw-border-neutral-700\\/40:is(.tw-dark *) {
    border-color: rgb(64 64 64 / 0.4);
}
.project-notes-scope .dark\\:tw-border-neutral-700\\/50:is(.tw-dark *) {
    border-color: rgb(64 64 64 / 0.5);
}
.project-notes-scope .dark\\:tw-border-neutral-700\\/70:is(.tw-dark *) {
    border-color: rgb(64 64 64 / 0.7);
}
.project-notes-scope .dark\\:tw-border-neutral-700\\/80:is(.tw-dark *) {
    border-color: rgb(64 64 64 / 0.8);
}
.project-notes-scope .dark\\:tw-border-red-600:is(.tw-dark *) {
    --tw-border-opacity: 1;
    border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}
.project-notes-scope .dark\\:tw-bg-\\[\\#00b7ff\\]:is(.tw-dark *) {
    --tw-bg-opacity: 1;
    background-color: rgb(0 183 255 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .dark\\:tw-bg-\\[\\#00b7ff\\]\\/10:is(.tw-dark *) {
    background-color: rgb(0 183 255 / 0.1);
}
.project-notes-scope .dark\\:tw-bg-\\[\\#1e1e2e\\]\\/85:is(.tw-dark *) {
    background-color: rgb(30 30 46 / 0.85);
}
.project-notes-scope .dark\\:tw-bg-\\[\\#1e1e2e\\]\\/90:is(.tw-dark *) {
    background-color: rgb(30 30 46 / 0.9);
}
.project-notes-scope .dark\\:tw-bg-\\[\\#333333\\]:is(.tw-dark *) {
    --tw-bg-opacity: 1;
    background-color: rgb(51 51 51 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .dark\\:tw-bg-\\[\\#33c686\\]:is(.tw-dark *) {
    --tw-bg-opacity: 1;
    background-color: rgb(51 198 134 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .dark\\:tw-bg-\\[\\#b7c5ff\\]\\/10:is(.tw-dark *) {
    background-color: rgb(183 197 255 / 0.1);
}
.project-notes-scope .dark\\:tw-bg-\\[rgb\\(var\\(--pill-accent-rgb\\)\\/0\\.15\\)\\]:is(.tw-dark *) {
    background-color: rgb(var(--pill-accent-rgb)/0.15);
}
.project-notes-scope .dark\\:tw-bg-amber-950:is(.tw-dark *) {
    --tw-bg-opacity: 1;
    background-color: rgb(69 26 3 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .dark\\:tw-bg-gray-600\\/60:is(.tw-dark *) {
    background-color: rgb(75 85 99 / 0.6);
}
.project-notes-scope .dark\\:tw-bg-neutral-700:is(.tw-dark *) {
    --tw-bg-opacity: 1;
    background-color: rgb(64 64 64 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .dark\\:tw-bg-neutral-700\\/40:is(.tw-dark *) {
    background-color: rgb(64 64 64 / 0.4);
}
.project-notes-scope .dark\\:tw-bg-neutral-700\\/50:is(.tw-dark *) {
    background-color: rgb(64 64 64 / 0.5);
}
.project-notes-scope .dark\\:tw-bg-neutral-800:is(.tw-dark *) {
    --tw-bg-opacity: 1;
    background-color: rgb(38 38 38 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .dark\\:tw-bg-neutral-800\\/30:is(.tw-dark *) {
    background-color: rgb(38 38 38 / 0.3);
}
.project-notes-scope .dark\\:tw-bg-neutral-800\\/40:is(.tw-dark *) {
    background-color: rgb(38 38 38 / 0.4);
}
.project-notes-scope .dark\\:tw-bg-neutral-800\\/50:is(.tw-dark *) {
    background-color: rgb(38 38 38 / 0.5);
}
.project-notes-scope .dark\\:tw-bg-neutral-900:is(.tw-dark *) {
    --tw-bg-opacity: 1;
    background-color: rgb(23 23 23 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .dark\\:tw-bg-red-800\\/50:is(.tw-dark *) {
    background-color: rgb(153 27 27 / 0.5);
}
.project-notes-scope .dark\\:tw-text-\\[\\#00b7ff\\]:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(0 183 255 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:tw-text-\\[\\#0b2a1d\\]:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(11 42 29 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:tw-text-\\[\\#33c686\\]:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(51 198 134 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:tw-text-\\[\\#b3b3b3\\]:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(179 179 179 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:tw-text-\\[\\#b7c5ff\\]:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(183 197 255 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:tw-text-amber-100:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(254 243 199 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:tw-text-amber-400:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:tw-text-blue-400:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:tw-text-foreground:is(.tw-dark *) {
    color: var(--foreground);
}
.project-notes-scope .dark\\:tw-text-gray-200:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:tw-text-neutral-100:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(245 245 245 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:tw-text-neutral-200:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(229 229 229 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:tw-text-neutral-300:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(212 212 212 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:tw-text-neutral-400:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(163 163 163 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:tw-text-neutral-500:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(115 115 115 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:tw-text-neutral-600:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(82 82 82 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:tw-text-red-400:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:tw-text-red-500:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:tw-shadow-black\\/30:is(.tw-dark *) {
    --tw-shadow-color: rgb(0 0 0 / 0.3);
    --tw-shadow: var(--tw-shadow-colored);
}
.project-notes-scope .dark\\:tw-shadow-black\\/60:is(.tw-dark *) {
    --tw-shadow-color: rgb(0 0 0 / 0.6);
    --tw-shadow: var(--tw-shadow-colored);
}
.project-notes-scope .dark\\:placeholder\\:tw-text-neutral-500:is(.tw-dark *)::-moz-placeholder {
    --tw-text-opacity: 1;
    color: rgb(115 115 115 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:placeholder\\:tw-text-neutral-500:is(.tw-dark *)::placeholder {
    --tw-text-opacity: 1;
    color: rgb(115 115 115 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:focus-within\\:tw-border-neutral-600:focus-within:is(.tw-dark *) {
    --tw-border-opacity: 1;
    border-color: rgb(82 82 82 / var(--tw-border-opacity, 1));
}
.project-notes-scope .dark\\:focus-within\\:tw-ring-neutral-600\\/30:focus-within:is(.tw-dark *) {
    --tw-ring-color: rgb(82 82 82 / 0.3);
}
.project-notes-scope .dark\\:hover\\:tw-border-\\[\\#00b7ff\\]:hover:is(.tw-dark *) {
    --tw-border-opacity: 1;
    border-color: rgb(0 183 255 / var(--tw-border-opacity, 1));
}
.project-notes-scope .dark\\:hover\\:tw-border-\\[\\#5ad49d\\]:hover:is(.tw-dark *) {
    --tw-border-opacity: 1;
    border-color: rgb(90 212 157 / var(--tw-border-opacity, 1));
}
.project-notes-scope .dark\\:hover\\:tw-border-\\[rgba\\(35\\2c 131\\2c 226\\2c 0\\.3\\)\\]:hover:is(.tw-dark *) {
    border-color: rgba(35,131,226,0.3);
}
.project-notes-scope .dark\\:hover\\:tw-border-neutral-500\\/60:hover:is(.tw-dark *) {
    border-color: rgb(115 115 115 / 0.6);
}
.project-notes-scope .dark\\:hover\\:tw-bg-\\[\\#00b7ff\\]\\/10:hover:is(.tw-dark *) {
    background-color: rgb(0 183 255 / 0.1);
}
.project-notes-scope .dark\\:hover\\:tw-bg-\\[\\#5ad49d\\]:hover:is(.tw-dark *) {
    --tw-bg-opacity: 1;
    background-color: rgb(90 212 157 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .dark\\:hover\\:tw-bg-\\[\\#b7c5ff\\]\\/10:hover:is(.tw-dark *) {
    background-color: rgb(183 197 255 / 0.1);
}
.project-notes-scope .dark\\:hover\\:tw-bg-\\[rgba\\(35\\2c 131\\2c 226\\2c 0\\.15\\)\\]:hover:is(.tw-dark *) {
    background-color: rgba(35,131,226,0.15);
}
.project-notes-scope .dark\\:hover\\:tw-bg-gray-700\\/60:hover:is(.tw-dark *) {
    background-color: rgb(55 65 81 / 0.6);
}
.project-notes-scope .dark\\:hover\\:tw-bg-neutral-600:hover:is(.tw-dark *) {
    --tw-bg-opacity: 1;
    background-color: rgb(82 82 82 / var(--tw-bg-opacity, 1));
}
.project-notes-scope .dark\\:hover\\:tw-bg-neutral-700\\/50:hover:is(.tw-dark *) {
    background-color: rgb(64 64 64 / 0.5);
}
.project-notes-scope .dark\\:hover\\:tw-bg-neutral-700\\/60:hover:is(.tw-dark *) {
    background-color: rgb(64 64 64 / 0.6);
}
.project-notes-scope .dark\\:hover\\:tw-bg-neutral-800\\/70:hover:is(.tw-dark *) {
    background-color: rgb(38 38 38 / 0.7);
}
.project-notes-scope .dark\\:hover\\:tw-text-\\[rgba\\(35\\2c 131\\2c 226\\2c 0\\.9\\)\\]:hover:is(.tw-dark *) {
    color: rgba(35,131,226,0.9);
}
.project-notes-scope .dark\\:hover\\:tw-text-neutral-200:hover:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(229 229 229 / var(--tw-text-opacity, 1));
}
.project-notes-scope .dark\\:hover\\:tw-text-neutral-300:hover:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(212 212 212 / var(--tw-text-opacity, 1));
}
.project-notes-scope :is(.tw-group:hover .dark\\:group-hover\\:tw-bg-neutral-700\\/60:is(.tw-dark *)) {
    background-color: rgb(64 64 64 / 0.6);
}
@media (min-width: 640px) {
    .project-notes-scope .sm\\:tw-inline-flex {
        display: inline-flex;
    }
    .project-notes-scope .sm\\:tw-min-w-\\[140px\\] {
        min-width: 140px;
    }
    .project-notes-scope .sm\\:tw-grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .project-notes-scope .sm\\:tw-grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .project-notes-scope .sm\\:tw-gap-2 {
        gap: 0.5rem;
    }
    .project-notes-scope .sm\\:tw-p-6 {
        padding: 1.5rem;
    }
    .project-notes-scope .sm\\:tw-p-8 {
        padding: 2rem;
    }
    .project-notes-scope .sm\\:tw-px-6 {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
    }
}
@media (min-width: 1024px) {
    .project-notes-scope .lg\\:tw-grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 1fr\\)\\] {
        grid-template-columns: minmax(0,1fr) minmax(0,1fr);
    }
    .project-notes-scope .lg\\:tw-gap-12 {
        gap: 3rem;
    }
}
.project-notes-scope .\\[\\&\\:not\\(\\:has\\(button\\2c iframe\\)\\)\\]\\:tw-hidden:not(:has(button,iframe)) {
    display: none;
}
.project-notes-scope :is(.\\[\\&\\>svg\\]\\:tw-pointer-events-none>svg) {
    pointer-events: none;
}
.project-notes-scope :is(.\\[\\&\\>svg\\]\\:\\!tw-size-3>svg) {
    width: 0.75rem !important;
    height: 0.75rem !important;
}
.project-notes-scope :is(.\\[\\&_b\\]\\:tw-font-semibold b) {
    font-weight: 600;
}
.project-notes-scope :is(.\\[\\&_b\\]\\:tw-text-neutral-900 b) {
    --tw-text-opacity: 1;
    color: rgb(23 23 23 / var(--tw-text-opacity, 1));
}
.project-notes-scope :is(.dark\\:\\[\\&_b\\]\\:tw-text-neutral-100 b:is(.tw-dark *)) {
    --tw-text-opacity: 1;
    color: rgb(245 245 245 / var(--tw-text-opacity, 1));
}
.project-notes-scope :is(.\\[\\&_blockquote\\]\\:tw-my-2 blockquote) {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}
.project-notes-scope :is(.\\[\\&_blockquote\\]\\:tw-border-l-2 blockquote) {
    border-left-width: 2px;
}
.project-notes-scope :is(.\\[\\&_blockquote\\]\\:tw-border-solid blockquote) {
    border-style: solid;
}
.project-notes-scope :is(.\\[\\&_blockquote\\]\\:tw-border-neutral-300 blockquote) {
    --tw-border-opacity: 1;
    border-color: rgb(212 212 212 / var(--tw-border-opacity, 1));
}
.project-notes-scope :is(.\\[\\&_blockquote\\]\\:tw-pl-3 blockquote) {
    padding-left: 0.75rem;
}
.project-notes-scope :is(.\\[\\&_blockquote\\]\\:tw-italic blockquote) {
    font-style: italic;
}
.project-notes-scope :is(.\\[\\&_blockquote\\]\\:tw-text-neutral-600 blockquote) {
    --tw-text-opacity: 1;
    color: rgb(82 82 82 / var(--tw-text-opacity, 1));
}
.project-notes-scope :is(.dark\\:\\[\\&_blockquote\\]\\:tw-border-neutral-600 blockquote:is(.tw-dark *)) {
    --tw-border-opacity: 1;
    border-color: rgb(82 82 82 / var(--tw-border-opacity, 1));
}
.project-notes-scope :is(.dark\\:\\[\\&_blockquote\\]\\:tw-text-neutral-400 blockquote:is(.tw-dark *)) {
    --tw-text-opacity: 1;
    color: rgb(163 163 163 / var(--tw-text-opacity, 1));
}
.project-notes-scope :is(.\\[\\&_em\\]\\:tw-italic em) {
    font-style: italic;
}
.project-notes-scope :is(.\\[\\&_em\\]\\:tw-text-neutral-600 em) {
    --tw-text-opacity: 1;
    color: rgb(82 82 82 / var(--tw-text-opacity, 1));
}
.project-notes-scope :is(.dark\\:\\[\\&_em\\]\\:tw-text-neutral-300 em:is(.tw-dark *)) {
    --tw-text-opacity: 1;
    color: rgb(212 212 212 / var(--tw-text-opacity, 1));
}
.project-notes-scope :is(.\\[\\&_h2\\]\\:tw-mb-1 h2) {
    margin-bottom: 0.25rem;
}
.project-notes-scope :is(.\\[\\&_h2\\]\\:tw-mt-3 h2) {
    margin-top: 0.75rem;
}
.project-notes-scope :is(.\\[\\&_h2\\]\\:tw-text-base h2) {
    font-size: 1rem;
    line-height: 1.5rem;
}
.project-notes-scope :is(.\\[\\&_h2\\]\\:tw-font-semibold h2) {
    font-weight: 600;
}
.project-notes-scope :is(.\\[\\&_h2\\]\\:tw-text-neutral-900 h2) {
    --tw-text-opacity: 1;
    color: rgb(23 23 23 / var(--tw-text-opacity, 1));
}
.project-notes-scope :is(.dark\\:\\[\\&_h2\\]\\:tw-text-neutral-100 h2:is(.tw-dark *)) {
    --tw-text-opacity: 1;
    color: rgb(245 245 245 / var(--tw-text-opacity, 1));
}
.project-notes-scope :is(.\\[\\&_h3\\]\\:tw-mb-1 h3) {
    margin-bottom: 0.25rem;
}
.project-notes-scope :is(.\\[\\&_h3\\]\\:tw-mt-2 h3) {
    margin-top: 0.5rem;
}
.project-notes-scope :is(.\\[\\&_h3\\]\\:tw-text-sm h3) {
    font-size: 0.875rem;
    line-height: 1.25rem;
}
.project-notes-scope :is(.\\[\\&_h3\\]\\:tw-font-semibold h3) {
    font-weight: 600;
}
.project-notes-scope :is(.\\[\\&_h3\\]\\:tw-text-neutral-800 h3) {
    --tw-text-opacity: 1;
    color: rgb(38 38 38 / var(--tw-text-opacity, 1));
}
.project-notes-scope :is(.dark\\:\\[\\&_h3\\]\\:tw-text-neutral-200 h3:is(.tw-dark *)) {
    --tw-text-opacity: 1;
    color: rgb(229 229 229 / var(--tw-text-opacity, 1));
}
.project-notes-scope :is(.\\[\\&_hr\\]\\:tw-my-3 hr) {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
}
.project-notes-scope :is(.\\[\\&_hr\\]\\:tw-border-neutral-200 hr) {
    --tw-border-opacity: 1;
    border-color: rgb(229 229 229 / var(--tw-border-opacity, 1));
}
.project-notes-scope :is(.dark\\:\\[\\&_hr\\]\\:tw-border-neutral-700\\/50 hr:is(.tw-dark *)) {
    border-color: rgb(64 64 64 / 0.5);
}
.project-notes-scope :is(.\\[\\&_i\\]\\:tw-italic i) {
    font-style: italic;
}
.project-notes-scope :is(.\\[\\&_i\\]\\:tw-text-neutral-600 i) {
    --tw-text-opacity: 1;
    color: rgb(82 82 82 / var(--tw-text-opacity, 1));
}
.project-notes-scope :is(.dark\\:\\[\\&_i\\]\\:tw-text-neutral-300 i:is(.tw-dark *)) {
    --tw-text-opacity: 1;
    color: rgb(212 212 212 / var(--tw-text-opacity, 1));
}
.project-notes-scope :is(.\\[\\&_li\\]\\:tw-mb-0\\.5 li) {
    margin-bottom: 0.125rem;
}
.project-notes-scope :is(.\\[\\&_li\\]\\:tw-text-neutral-700 li) {
    --tw-text-opacity: 1;
    color: rgb(64 64 64 / var(--tw-text-opacity, 1));
}
.project-notes-scope :is(.dark\\:\\[\\&_li\\]\\:tw-text-neutral-300 li:is(.tw-dark *)) {
    --tw-text-opacity: 1;
    color: rgb(212 212 212 / var(--tw-text-opacity, 1));
}
.project-notes-scope :is(.\\[\\&_ol\\]\\:tw-my-1 ol) {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
}
.project-notes-scope :is(.\\[\\&_ol\\]\\:tw-list-decimal ol) {
    list-style-type: decimal;
}
.project-notes-scope :is(.\\[\\&_ol\\]\\:tw-pl-5 ol) {
    padding-left: 1.25rem;
}
.project-notes-scope :is(.\\[\\&_strong\\]\\:tw-font-semibold strong) {
    font-weight: 600;
}
.project-notes-scope :is(.\\[\\&_strong\\]\\:tw-text-neutral-900 strong) {
    --tw-text-opacity: 1;
    color: rgb(23 23 23 / var(--tw-text-opacity, 1));
}
.project-notes-scope :is(.dark\\:\\[\\&_strong\\]\\:tw-text-neutral-100 strong:is(.tw-dark *)) {
    --tw-text-opacity: 1;
    color: rgb(245 245 245 / var(--tw-text-opacity, 1));
}
.project-notes-scope :is(.\\[\\&_svg\\:not\\(\\[class\\*\\=\\"size-\\"\\]\\)\\]\\:tw-size-3 svg:not([class*="size-"])) {
    width: 0.75rem;
    height: 0.75rem;
}
.project-notes-scope :is(.\\[\\&_svg\\:not\\(\\[class\\*\\=\\"size-\\"\\]\\)\\]\\:tw-size-3\\.5 svg:not([class*="size-"])) {
    width: 0.875rem;
    height: 0.875rem;
}
.project-notes-scope :is(.\\[\\&_svg\\:not\\(\\[class\\*\\=\\"size-\\"\\]\\)\\]\\:tw-size-4 svg:not([class*="size-"])) {
    width: 1rem;
    height: 1rem;
}
.project-notes-scope :is(.\\[\\&_svg\\]\\:tw-pointer-events-none svg) {
    pointer-events: none;
}
.project-notes-scope :is(.\\[\\&_svg\\]\\:tw-shrink-0 svg) {
    flex-shrink: 0;
}
.project-notes-scope :is(.\\[\\&_ul\\]\\:tw-my-1 ul) {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
}
.project-notes-scope :is(.\\[\\&_ul\\]\\:tw-list-disc ul) {
    list-style-type: disc;
}
.project-notes-scope :is(.\\[\\&_ul\\]\\:tw-pl-5 ul) {
    padding-left: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./views/react/components/ProjectNotes/projectNotes.css"],"names":[],"mappings":"AACA;IAAA,kBAAmB;IAAnB,UAAmB;IAAnB,WAAmB;IAAnB,UAAmB;IAAnB,YAAmB;IAAnB,gBAAmB;IAAnB,sBAAmB;IAAnB,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,SAAmB;IAAnB;AAAmB;AAAnB;IAAA,QAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,cAAmB;IAAnB;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA,WAAmB;IAAnB;AAAmB;AAAnB;IAAA,aAAmB;IAAnB;AAAmB;AAAnB;IAAA,cAAmB;IAAnB;AAAmB;AAAnB;IAAA,WAAmB;IAAnB;AAAmB;AAAnB;IAAA,cAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;QAAA;IAAmB;IAAnB;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,yBAAmB;OAAnB,sBAAmB;YAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,wBAAmB;OAAnB,qBAAmB;YAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,yBAAmB;SAAnB;AAAmB;AAAnB;IAAA,uBAAmB;SAAnB;AAAmB;AAAnB;IAAA,yBAAmB;SAAnB;AAAmB;AAAnB;IAAA,qBAAmB;SAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,gEAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,gEAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,+DAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gDAAmB;IAAnB,6DAAmB;IAAnB;AAAmB;AAAnB;IAAA,+EAAmB;IAAnB,mGAAmB;IAAnB;AAAmB;AAAnB;IAAA,6EAAmB;IAAnB,iGAAmB;IAAnB;AAAmB;AAAnB;IAAA,0CAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,gFAAmB;IAAnB,oGAAmB;IAAnB;AAAmB;AAAnB;IAAA,mCAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,+FAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;;AAEnB;;;;;EAKE;AACF;IACI,qBAAqB;IACrB,qBAAqB;IACrB;;iEAE6D;IAC7D,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;IAClB,6BAA6B;IAC7B,oBAAoB;IACpB,+BAA+B;IAC/B,gBAAgB;IAChB,2BAA2B;IAC3B,sBAAsB;IACtB,iCAAiC;IACjC,sEAAsE;IACtE,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;IAClB,6BAA6B;IAC7B,oBAAoB;IACpB,+BAA+B;IAC/B,gBAAgB;IAChB,2BAA2B;IAC3B,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;;;;;;;;EASE;AACF;IACI,UAAU;IACV,eAAe;IACf,sBAAsB;AAC1B;;AAEA;;;;;EAKE;AACF;IACI,wBAAwB;AAC5B;;AAEA;;;;EAIE;AACF;IACI;;;mCAG+B;IAC/B,mBAAmB;IACnB,qBAAqB;IACrB,0DAA0D;AAC9D;AACA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;AACA;IACI,gCAAgC;AACpC;;AAEA;;;;;EAKE;AACF;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;AAClC;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;;;IAGI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,mCAAmC;AACvC;AA1IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,sBA2IA;IA3IA;AA2IA;AA3IA;IAAA,2GA2IA;IA3IA,yGA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,sBA2IA;IA3IA;AA2IA;AA3IA;IAAA,sBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,sBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,kBA2IA;IA3IA;AA2IA;AA3IA;IAAA,kBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,kBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,kBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,8BA2IA;IA3IA;AA2IA;AA3IA;IAAA,2GA2IA;IA3IA,yGA2IA;IA3IA;AA2IA;AA3IA;IAAA,2GA2IA;IA3IA,yGA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,2GA2IA;IA3IA,yGA2IA;IA3IA;AA2IA;AA3IA;IAAA,qBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,kBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,sBA2IA;IA3IA;AA2IA;AA3IA;IAAA,sBA2IA;IA3IA;AA2IA;AA3IA;IAAA,sBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,sBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,sBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,sBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,sBA2IA;IA3IA;AA2IA;AA3IA;IAAA,kBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,kBA2IA;IA3IA;AA2IA;AA3IA;IAAA,kBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,kBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,kBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,kBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,kBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,mCA2IA;IA3IA;AA2IA;AA3IA;IAAA,mCA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,sBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,sBA2IA;IA3IA;AA2IA;AA3IA;IAAA,sBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,kBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,kBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;QAAA;IA2IA;IA3IA;QAAA;IA2IA;IA3IA;QAAA;IA2IA;IA3IA;QAAA;IA2IA;IA3IA;QAAA;IA2IA;IA3IA;QAAA;IA2IA;IA3IA;QAAA;IA2IA;IA3IA;QAAA,oBA2IA;QA3IA;IA2IA;AAAA;AA3IA;IAAA;QAAA;IA2IA;IA3IA;QAAA;IA2IA;AAAA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,yBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,kBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,sBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,sBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,eA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,mBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,mBA2IA;IA3IA;AA2IA;AA3IA;IAAA,sBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,mBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,oBA2IA;IA3IA;AA2IA;AA3IA;IAAA,cA2IA;IA3IA;AA2IA;AA3IA;IAAA,eA2IA;IA3IA;AA2IA;AA3IA;IAAA,WA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA,mBA2IA;IA3IA;AA2IA;AA3IA;IAAA;AA2IA;AA3IA;IAAA;AA2IA","sourcesContent":["@tailwind components;\n@tailwind utilities;\n\n/*\n * Semantic color tokens for the ui/ component library (Button, Badge, etc.).\n * These map the tw-bg-primary, tw-text-foreground, tw-bg-muted etc. classes\n * that CVA variants reference. Without these, those classes resolve to nothing\n * since we omitted @tailwind base.\n */\n.project-notes-scope {\n    --background: #ffffff;\n    --foreground: #171717;\n    /* Raised surface: dialogs, plan cards, the auth card. In light it matches\n       the page and separates via border + shadow; in dark it must sit above\n       the page, which is why the two values are not symmetric. */\n    --card: #ffffff;\n    --card-foreground: #171717;\n    --primary: #171717;\n    --primary-foreground: #fafafa;\n    --secondary: #f5f5f5;\n    --secondary-foreground: #171717;\n    --muted: #f5f5f5;\n    --muted-foreground: #737373;\n    --destructive: #ef4444;\n    --destructive-foreground: #fafafa;\n    /* The comparison table's \"included\" green (PricingComparisonModal). */\n    --success: #22c55e;\n    --success-foreground: #ffffff;\n    --border: #e5e5e5;\n    --input: #e5e5e5;\n    --ring: #a3a3a3;\n}\n\n.tw-dark .project-notes-scope {\n    --background: #171717;\n    --foreground: #fafafa;\n    --card: #1f1f1f;\n    --card-foreground: #fafafa;\n    --primary: #fafafa;\n    --primary-foreground: #171717;\n    --secondary: #262626;\n    --secondary-foreground: #fafafa;\n    --muted: #262626;\n    --muted-foreground: #a3a3a3;\n    --destructive: #dc2626;\n    --destructive-foreground: #fafafa;\n    --success: #4ade80;\n    --success-foreground: #171717;\n    --border: #404040;\n    --input: #404040;\n    --ring: #525252;\n}\n\n/*\n * Reset global button{} styles from style.css within our scope. The auth pages\n * sit in the marketing theme instead and keep its .btn; :where() excludes them\n * without raising the reset's specificity above the utilities. Payment buttons\n * drawn by Google/Apple (.cb-wallets) are excluded too: unset, Google Pay's\n * button collapses to zero height.\n * The Tailwind utilities have higher specificity via\n * important: '.project-notes-scope' in tailwind.config.js,\n * so they override this reset cleanly.\n */\n.project-notes-scope:where(:not(.auth-page)) button:where(:not(.cb-wallets *)) {\n    all: unset;\n    cursor: pointer;\n    box-sizing: border-box;\n}\n\n/*\n * Legacy Project Notes trigger — hidden in favor of the React PanelToggles.\n * The element stays in DOM because legacyBridge.js relies on it being there\n * when re-stubbing window.getGraphInfoToggle. We use !important because the\n * tooltipster jQuery plugin clears inline `style=\"display:none\"` after init.\n */\n#info-link {\n    display: none !important;\n}\n\n/*\n * Chargebee card fields (/upgrade). The inputs themselves live in Chargebee\n * iframes, so the only styling the app controls is the box around them plus\n * the classes Chargebee toggles on that box (useChargebeeCheckout.js).\n */\n.project-notes-scope .cb-field {\n    /* Chargebee's inputs paint themselves white and expose no background in\n       their style API, so the box around them is light in both themes and the\n       text colour handed to Chargebee is dark to match\n       (useChargebeeCheckout.js). */\n    background: #ffffff;\n    border-color: #d4d4d8;\n    transition: border-color 120ms ease, box-shadow 120ms ease;\n}\n.project-notes-scope .cb-field.is-focus {\n    border-color: #6366f1;\n    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.25);\n}\n.project-notes-scope .cb-field.is-invalid {\n    border-color: var(--destructive);\n}\n\n/*\n * One shape for the three providers' payment buttons. Iframes keep a light\n * colour scheme: on dark pages Chromium paints an opaque backdrop behind them\n * (white corners around PayPal). The element selector outranks Google's\n * later-injected .gpay-button rules.\n */\n.project-notes-scope .cb-wallets > [id^='cb-wallet-'] {\n    height: 45px;\n    border-radius: 4px;\n    overflow: hidden;\n    transition: opacity 0.15s ease;\n}\n.project-notes-scope .cb-wallets > [id^='cb-wallet-']:hover {\n    opacity: 0.85;\n}\n.project-notes-scope .cb-wallets iframe {\n    color-scheme: light;\n}\n.project-notes-scope .cb-wallets button.gpay-button,\n.project-notes-scope .cb-wallets button.gpay-button:hover,\n.project-notes-scope .cb-wallets button.gpay-button:focus {\n    display: block;\n    width: 100%;\n    min-width: 0;\n    height: 45px;\n    min-height: 45px;\n    border: 0;\n    border-radius: 0;\n    box-shadow: none;\n    outline: none;\n    background-color: #000;\n    box-sizing: border-box;\n}\n.project-notes-scope .cb-wallets #cb-wallet-apple-pay {\n    --apple-pay-button-width: 100%;\n    --apple-pay-button-height: 45px;\n    --apple-pay-button-border-radius: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
